/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { calendarService } from '@/services';
import get from 'lodash/get';

export const state = {
  calendar: {},
};

export const getters = {
  calendar: state => get(state.calendar, ['items']) || [],
};

export const actions = {
  init({ state, dispatch }) {
    state.calendar = false;
  },
  async getCalendar({ commit, dispatch }, { id, year, month }) {
    try {
      const response = await calendarService.getCalendar(id, year, month);
      commit('getAllSuccess', response.data);
    } catch (error) {
      dispatch(
        'notificationService',
        { type: 'error', text: error },
        { root: true },
      );
    }
  },
};

export const mutations = {
  getAllSuccess(state, calendar) {
    state.calendar = {
      items: calendar,
    };
  },
  getAllFailure(state, error) {
    state.calendar = {
      error,
    };
  },
  addAllSuccess(state, calendar) {
    state.calendar = {
      items: calendar,
    };
  },
};
